
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProspectStatusEnum } from '../models/work-prospect-status-enum';

export function getUpdateProspectDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    objectStreet: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    objectZip: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    objectCity: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    objectCanton: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    latitude: new FormControl<number | undefined>(undefined),
    longitude: new FormControl<number | undefined>(undefined),
    company: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    firstName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    lastName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    phone: new FormControl<string | undefined>(undefined, [Validators.maxLength(45)]),
    email: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    containertypeId: new FormControl<number | undefined>(undefined),
    assigneeId: new FormControl<number | undefined>(undefined),
    status: new FormControl<WorkProspectStatusEnum | undefined>(undefined),
    active: new FormControl<boolean | undefined>(undefined),
})
;
}
      